const toAccount = (value = '') => value.split(' ').join('');

export const required = value => (!value ? 'validation.required' : undefined);

export const minAmount = min => (value = 0) =>
  value < min ? 'validation.min' : undefined;

export const maxAmount = max => (value = 0) =>
  value > max ? 'validation.max' : undefined;

export const min10k = minAmount(10000);
export const max10m = maxAmount(10000000);

export const len8 = value =>
  toAccount(value).length < 8 ? 'validation.custNumber' : undefined;
export const len16 = value =>
  toAccount(value).length < 16 ? 'validation.custNumber' : undefined;

export const checkPhone = (prefixs = []) => (value = '') => {
  let validationError = true;
  let stateValue = '';
  const checkValue = toAccount(value);

  if (prefixs.length) {
    prefixs.forEach(prefix => {
      if (checkValue.substr(0, prefix.length).match(prefix)) {
        validationError = false;
        stateValue = 'prefix';
      }
    });
  } else if (checkValue.match('(628|08)')) {
    validationError = false;
    stateValue = 'phone';
  }

  if (stateValue === 'phone' && checkValue.length < 11) {
    return 'validation.custNumber';
  }

  if (stateValue === 'prefix' && checkValue.length < 16) {
    return 'validation.accountNumber';
  }

  return validationError && checkValue.length > 4
    ? 'validation.incorrectPrefix'
    : undefined;
};

export const checkPrefix = (prefixs = []) => (value = '') => {
  let validationError = true;
  const checkValue = toAccount(value);
  prefixs.forEach(prefix => {
    if (checkValue.substr(0, prefix.length).match(prefix)) {
      validationError = false;
    }
  });

  if (checkValue.length < 10) {
    return 'validation.custNumber';
  }

  return validationError && checkValue.length > 4
    ? 'validation.incorrectPrefix'
    : undefined;
};

export const creditCard = (cardNum = '') => {
  const error = 'validation.incorrectCC';

  const value = cardNum.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
  const len = value.length;

  if (len >= 16) {
    const parity = len % 2;
    let sum = 0;
    for (let i = len - 1; i >= 0; i -= 1) {
      let d = parseInt(value.charAt(i), 10);
      if (i % 2 === parity) {
        d *= 2;
      }
      if (d > 9) {
        d -= 9;
      }
      sum += d;
    }

    if (sum % 10 === 0) {
      let cardType = '';

      const regexMap = [
        { regEx: /^4[0-9]{5}/gi, cardType: 'VISA' },
        { regEx: /^5[1-5][0-9]{4}/gi, cardType: 'MASTERCARD' },
      ];

      // Do Maping For Regex
      for (let j = 0; j < regexMap.length; j += 1) {
        if (value.match(regexMap[j].regEx)) {
          cardType = regexMap[j].cardType;
          break;
        }
      }

      return cardType === '' ? 'validation.allowCC' : undefined;
    }
    return error;
  }
  return undefined;
};
